export default {
  likesItQuery(state) {
    return (foreignType, foreignId) => !!state.likes[`${foreignType}__${foreignId}`]
  },
}
